import { STRAPI_DEVELOPMENT, STRAPI_PRODUCTION } from "../../constants/Api";

export const authenticate = (pathName, search) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${
        process.env.NODE_ENV === "production"
          ? STRAPI_PRODUCTION
          : STRAPI_DEVELOPMENT
      }${pathName}${search}`
    )
      .then(async (data) => await data.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
